import React, { Component } from 'react';
import "react-image-lightbox/style.css";
import Lightbox from "react-image-lightbox";
  
class GalleryWidgetIframe extends Component {
    state = { 
      isContent: true,
      photos: [],
      photoIndex: 0,
      isOpen: false,
      loading: true,
    }
    receiveMessage = (e) => {
        if (e.data === 'noContent') {
          this.setState({
            isContent: false,
          });
      }
      if (e.data.clicked !== undefined) {
          this.setState({
              photos: e.data.data,
              loading: false,
              isOpen: true, 
              photoIndex: e.data.clickedIndex
          })
        }
      };
    render() { 
      const { url } = this.props;
      const { photos, photoIndex, isOpen, loading } = this.state;
      const images = photos && photos.length > 0 ? photos : null;
      return ( 
        <>
          <iframe className="widgetGalleryIframe" style={!this.state.isContent ? {minHeight: 0,height: 65, marginBottom: 4, border: '1px solid #bdb0b0'} : {}} src={url}></iframe> 
       {/* ************************** For light box ************************* */}
       {!loading && isOpen && (
                    <Lightbox
                        mainSrc={images[photoIndex].cover.teaser}
                        imageTitle={images[photoIndex].name}
                        imageCaption={images[photoIndex].description}
                        nextSrc={images[(photoIndex + 1) % images.length].cover.teaser}
                        prevSrc={images[(photoIndex + images.length - 1) % images.length].cover.teaser}
                        onCloseRequest={() => this.setState({ isOpen: false })}
                        onMovePrevRequest={() =>
                            this.setState({
                            photoIndex: (photoIndex + images.length - 1) % images.length
                            })
                        }
                        onMoveNextRequest={() =>
                            this.setState({
                            photoIndex: (photoIndex + 1) % images.length
                            })
                        }
                    />
                )}
       </>
        );
    }
      
    componentDidMount(){
        window.addEventListener('message', this.receiveMessage )
        // window.addEventListener('message', (e) => {
        //     console.log('message received...')
        // });
    }
}
 
export default GalleryWidgetIframe;